"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ReactIcon = _interopRequireDefault(require("./ReactIcon.style"));
var _excluded = ["className", "component", "size", "color", "bgColor", "bgRadius", "bgPadding", "id", "disabled", "onClick", "onTouchStart", "onTouchEnd", "onMouseDown", "onMouseUp"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * ReactIcon — SVG-based companion to the font-icon `Icon` component.
 * Pass any react-icons component via the `component` prop.
 *
 * Usage:
 *   import { FiChevronDown } from 'react-icons/fi';
 *   <ReactIcon component={FiChevronDown} size={20} color="#1E296B" />
 */
var ReactIcon = function ReactIcon(_ref) {
  var className = _ref.className,
    IconComponent = _ref.component,
    size = _ref.size,
    color = _ref.color,
    bgColor = _ref.bgColor,
    bgRadius = _ref.bgRadius,
    bgPadding = _ref.bgPadding,
    id = _ref.id,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    onTouchStart = _ref.onTouchStart,
    onTouchEnd = _ref.onTouchEnd,
    onMouseDown = _ref.onMouseDown,
    onMouseUp = _ref.onMouseUp,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (!IconComponent) return null;
  var interactiveProps = typeof onClick === 'function' && !disabled ? {
    onClick: onClick,
    onKeyDown: onClick,
    onTouchStart: onTouchStart,
    onTouchEnd: onTouchEnd,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    role: 'button',
    tabIndex: '0'
  } : {};
  return /*#__PURE__*/_react["default"].createElement(_ReactIcon["default"], _extends({
    className: className,
    size: size,
    color: color,
    bgColor: bgColor,
    bgRadius: bgRadius,
    bgPadding: bgPadding,
    id: id,
    disabled: disabled
  }, interactiveProps, otherProps), /*#__PURE__*/_react["default"].createElement(IconComponent, null));
};
ReactIcon.defaultProps = {
  className: '',
  component: null,
  size: 20,
  color: null,
  bgColor: null,
  bgRadius: null,
  bgPadding: null,
  id: '',
  disabled: false,
  onClick: null,
  onTouchStart: null,
  onTouchEnd: null,
  onMouseDown: null,
  onMouseUp: null
};
ReactIcon.propTypes = {
  className: _propTypes["default"].string,
  /** Any react-icons SVG component e.g. FiChevronDown from 'react-icons/fi' */
  component: _propTypes["default"].elementType,
  size: _propTypes["default"].number,
  /** CSS color string for the SVG stroke/fill */
  color: _propTypes["default"].string,
  /** Background color for the icon badge container */
  bgColor: _propTypes["default"].string,
  /** Border-radius for the badge; defaults to 8px when bgColor is set */
  bgRadius: _propTypes["default"].string,
  /** Padding for the badge; defaults to 10px when bgColor is set */
  bgPadding: _propTypes["default"].string,
  id: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  onTouchStart: _propTypes["default"].func,
  onTouchEnd: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(ReactIcon);